import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { OrgSwitchReloadState } from '../navigation/org-switch-reload';

/**
 * Where a guard sends a signed-in user it turns away: /unauthorized — except during an
 * org-switch reload, where the open page may simply not exist for their role in the new
 * org. Then it's their landing page (`/` → landingGuard → the first page in their side
 * nav), so they stay in the shell. Call it in the guard body (injection context), not
 * inside an observable callback.
 */
export function deniedUrl(): UrlTree {
  const router = inject(Router);
  return router.createUrlTree([inject(OrgSwitchReloadState).reloading ? '/' : '/unauthorized']);
}
